module.exports = __webpack_public_path__ + "img/chat.703e4b57.svg";